export default class Veiculo {
  constructor(id, descricao, cor, placa, renavam, ano, emplacamento) {
    this.id = id;
    this.descricao = descricao;
    this.cor = cor;
    this.placa = placa;
    this.renavam = renavam;
    this.ano = ano;
    this.emplacamento = emplacamento;
  }

  update(veiculo) {
    this.id = veiculo.id;
    this.descricao = veiculo.descricao;
    this.cor = veiculo.cor;
    this.placa = veiculo.placa;
    this.renavam = veiculo.renavam;
    this.ano = veiculo.ano;
    this.emplacamento = veiculo.emplacamento;
  }
}
